import Vue from "vue";
import Router from "vue-router";
import AuthPortalRoute from "./routers/authPortalRoute";
import SupportPageRoute from "./routers/supportPageRoute";
import GatewayRoute from "./routers/gatewayRoute";
import SearchRoute from "./routers/searchRoute";
import DetailPageRoute from "./routers/detailPageRoute";
import YourAccountRoute from "./routers/yourAccountRoute";
import CommonRoute from "./routers/commonRoute";
import ProductBrowseRoute from "./routers/productBrowseRoute";
import downloadRoute from "./routers/downloadRoute";
import downloadMobileRoute from "./routers/downloadMobileRoute";
import store from "./store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // base: '/1byone/',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },

  routes: [
    ...AuthPortalRoute,
    ...SupportPageRoute,
    ...GatewayRoute,
    ...SearchRoute,
    ...DetailPageRoute,
    ...YourAccountRoute,
    ...CommonRoute,
    ...ProductBrowseRoute,
    ...downloadRoute,
    ...downloadMobileRoute
   
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated != true) {
      next({ name: "signin" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
